var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formData)?_c('div',[_c('contactComments',{attrs:{"contact-id":_vm.contactId,"contact":_vm.formData,"form-key":_vm.formKey}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }